import {
  HttpEvent,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, take, switchMap, map, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

/**
 * The HTTP  interceptor  outing request to attach authorization token to it and catch errors from
 * HTTP call to display a message to the user
 */
@Injectable({
  providedIn: 'root',
})
export class ApiHttpInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  // intercept request and add Authorization token
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    return this.handleAccessToken(req, next);
  }

  private handleAccessToken(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.isLoggedIn().pipe(
      take(1),
      switchMap((isLoggedIn) => {
        if (isLoggedIn && (req.url.startsWith(environment.apiUrl) || req.url.startsWith(environment.loggingUrl))) {
          return this.authService.getIdToken().pipe(
            map((token) => req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })),
            switchMap((authReq) => next.handle(authReq)),
          );
        }
        return next.handle(req);
      }),
      catchError((error) => {
        console.error('HTTP error intercepted', error);
        return throwError(() => error);
      }),
    );
  }
}
